import type { NavGroup } from '../../components/layout';

/**
 * Shared sidebar navigation for every tenant page (single source of truth).
 *
 * ponytail: previously copy-pasted into each page, which is how the Recordings
 * link went missing from most of them. Add an item here, not to a page.
 */
export const NAV: NavGroup[] = [
  { active: 'dashboard', items: [{ to: '/dashboard', label: 'Dashboard', icon: '▦' }] },
  {
    section: 'Streaming',
    active: 'streams',
    items: [
      { to: '/streams', label: 'Streams', icon: '▶' },
      // ponytail: hard-coded to the "test1" stream as requested; make it
      // contextual (current stream / per-tenant first stream) when needed.
      { to: '/streams/test1/destinations', label: 'Destinations', icon: '🎯' },
      { to: '/recordings', label: 'Recordings', icon: '⏺' },
      { to: '/analytics', label: 'Analytics', icon: '📊' },
    ],
  },
  {
    section: 'Account',
    active: 'settings',
    items: [
      { to: '/billing', label: 'Billing', icon: '💳' },
      { to: '/transactions', label: 'Transactions', icon: '🧾' },
      { to: '/settings/profile', label: 'Settings', icon: '⚙' },
    ],
  },
  {
    section: 'Support',
    active: 'chat',
    items: [
      { to: '/chat', label: 'Support Chat', icon: '💬' },
    ],
  },
];